import { Component, OnInit } from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ConfiguracionGeneralService } from 'npm-servicios-catering';
import { Subscription } from 'rxjs';
import { ConfiguracionGeneral } from 'npm-modelado-catering';
import { Constantes } from '../../../compartido/constantes/constantes';


@Component({
  selector: 'app-configuracion-parametros-editar',
  templateUrl: './configuracion-parametros-editar.component.html',
  styleUrls: ['./configuracion-parametros-editar.component.css']
})
export class ConfiguracionParametrosEditarComponent extends LoadingPage implements OnInit {

  constructor(private router: Router, private routeParams: ActivatedRoute, private configuracionGeneralService: ConfiguracionGeneralService) { super(false); }

  idConfiguracionGeneral: number = -1;
  busy: Subscription;
  configuracionParametroRecuperado: ConfiguracionGeneral;
  valor: number;
  descripcion: string;
  nombre: string;
  isPorcentajeServicio: boolean = false;
  isTiempoLimiteCancelar: boolean = false;
  isTiempoLimiteConfirmar: boolean = false;
  isLimiteDiarioProduccion: boolean = false;
  textoCampoValor: string = "...";

  ngOnInit() {
    this.cargarEnviroment();
    console.log(this.routeParams.snapshot.queryParams['id']);
    if (this.routeParams.snapshot.queryParams['id']) {//si es para editar ya que vienen parámetros
      this.idConfiguracionGeneral = this.routeParams.snapshot.queryParams['id'];
      this.buscarByIdConfiguracionGeneral(this.idConfiguracionGeneral);
    }

  }

  redirectListado() {
    this.router.navigate(['/configuracion/configuracion-parametros/']);
  }
  buscarByIdConfiguracionGeneral(id) {
    this.busy = this.configuracionGeneralService.buscarByIdConfiguracionGeneral(id).then(conf => {
      if (conf) {
        this.configuracionParametroRecuperado = conf;
        this.valor = this.configuracionParametroRecuperado.valor;
        this.descripcion = this.configuracionParametroRecuperado.descripcion;
        this.nombre = this.configuracionParametroRecuperado.tipoConfiguracion;
        if (this.nombre.toLowerCase().localeCompare("porcentaje servicio catering") == 0) {
          this.isPorcentajeServicio = true;
          this.textoCampoValor = "Porcentaje:*";
        } else {
          if (this.nombre.toLowerCase().localeCompare("tiempo limite confirmar servicio") == 0) {
            this.isTiempoLimiteConfirmar = true;
            this.textoCampoValor = "Horas (múltiplos de 24):*";
          } else {
            if (this.nombre.toLowerCase().localeCompare("tiempo limite cancelar servicio") == 0) {
              this.isTiempoLimiteCancelar = true;
              this.textoCampoValor = "Horas (múltiplos de 24):*";
            } else {
              if (this.nombre.toLowerCase().localeCompare("limite diario de produccion") == 0) {
                this.isLimiteDiarioProduccion = true;
                this.textoCampoValor = "Valor*";
              }
            }
          }
        }
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de editar parámetro de configuración, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }
  cargarEnviroment() {
    this.configuracionGeneralService.set_constantes(Constantes);
  }
  async clickGuardar() {

    if (this.descripcion.trim().length > 0) {
      if (this.valor > 0) {
        if (this.valor < 100000) {
          if (this.isLimiteDiarioProduccion) {
            this.guardarConfiguracionParametro();
          } else {
            if (this.isPorcentajeServicio) {
              if (this.valor <= 100) {
                this.guardarConfiguracionParametro();
              } else {
                this.mostrarMensajeInfo("El porcentaje no puede ser mayor a 100%");
              }

            } else {
              if ((this.isTiempoLimiteConfirmar || this.isTiempoLimiteCancelar) && ((this.valor % 24) == 0)) {
                this.guardarConfiguracionParametro();
              } else {
                this.mostrarMensajeInfo("El valor ingresado debe ser múltiplo de 24");
              }
            }
          }
        } else {
          this.mostrarMensajeInfo("El valor ingresado debe ser menor a 100000");
        }
      } else {
        this.mostrarMensajeInfo("Debe ingresar un valor válido");
      }
    } else {
      this.mostrarMensajeInfo("Debe ingresar una descripción válida");
    }
  }
  cargarInformacionGuardarSubCategoria() {
    this.configuracionParametroRecuperado.valor = this.valor;
    this.configuracionParametroRecuperado.descripcion = this.descripcion.trim();
    this.configuracionParametroRecuperado.tipoConfiguracion = this.nombre;
  }
  async guardarConfiguracionParametro() {
    await this.cargarInformacionGuardarSubCategoria();
    this.configuracionGeneralService.actualizar(this.configuracionParametroRecuperado).then(req => {
      if (req) {
        this.mostrarMensajeInfo("Se ha actualizado correctamente el registro");
        this.router.navigate(['/configuracion/configuracion-parametros/']);
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });

  }
}
